"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Processor = void 0;
var Processor;
(function (Processor) {
    Processor["STRIPE"] = "stripe";
    Processor["UNKNOWN"] = "unknown";
})(Processor || (exports.Processor = Processor = {}));
